import { get } from "db/api";

export const getSubscription = async (id) => {
  try {
    const response = await get("/get-subscription/" + id);
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    return data;
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
